import React from 'react';
import Slider from 'react-slick';
import { Box, Container } from '@mui/material';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

interface HorizontalSliderProps {
  items: (React.ReactNode | string)[];
  settings?: Record<string, any>;
}

const HorizontalSlider: React.FC<HorizontalSliderProps> = ({ items, settings }) => {
  const SliderSettings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    responsive: [
      {
        breakpoint: 768,
        settings: { slidesToShow: 2 },
      },
      {
        breakpoint: 480,
        settings: { slidesToShow: 1 },
      },
    ],
    ...(settings ? { ...settings } : {}),
  };

  if (items.length === 0) {
    return null;
  }

  return (
    <Container sx={{ py: 4 }}>
      <Slider {...SliderSettings}>
        {items.map((item: React.ReactNode | string, index: number) => (
          <Box 
            key={`slick-slider-${index}`} 
            sx={{ 
              px: 1,
              outline: 'none',
            }}
          >
            {item}
          </Box>
        ))}
      </Slider>
    </Container>
  );
};

export default HorizontalSlider;
